var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { TIME_SLOTS } from "../../../classConstants";
import { Flex } from "../../Flex";
import groupBy from "lodash/groupBy";
import entries from "lodash/entries";
import padStart from "lodash/padStart";
import { dateFormat } from "../../../helpers/date";
import { NoDataToDisplay } from "../../NoDataToDisplay/NoDataToDisplay";
import { useTranslation } from "react-i18next";
import { Select } from "..";
import getHours from "date-fns/getHours";
export var TimeSlotDropdown = (function (props) {
    var t = useTranslation().t;
    var filteredSlots = props.filteredSlots, slots = props.slots, filters = props.filters, deriveSlotValue = props.deriveSlotValue, onSelect = props.onSelect, selected = props.selected;
    var getSlots = function (slots) {
        return slots.reduce(function (all, slot) {
            if (!slot.isAvailable) {
                return all;
            }
            var label = t("bookcart.timeslots.timeslot_label", {
                from: function () { return dateFormat(new Date(slot.from), t("bookcart.timeslots.timeslot_format")); },
                to: function () { return dateFormat(new Date(slot.to), t("bookcart.timeslots.timeslot_format")); },
                skipInterpolation: true
            });
            return all.concat({
                label: label,
                disabled: !slot.isAvailable,
                value: deriveSlotValue(slot),
            });
        }, []);
    };
    var getGroups = function () {
        // slots.length < 30
        //     ? filters.reduce((all, { name }) => {
        //         if (!filteredSlots[name]) return all;
        //         return all.concat({
        //             label: (`bookcart.timeslots.filters.${name}`),
        //             value: name,
        //             children: getSlots(filteredSlots[name])
        //         })
        //     }, [])
        // :
        return entries(groupBy(slots, function (_a) {
            var from = _a.from;
            return getHours(from);
        }))
            .reduce(function (all, _a) {
            var value = _a[0], subSlots = _a[1];
            var children = getSlots(subSlots);
            switch (children.length) {
                case 0: return all;
                case 1: return all.concat(children);
                default: return all.concat({
                    value: value,
                    label: padStart(value, 3) + ":00",
                    children: getSlots(subSlots)
                });
            }
        }, []);
    };
    var renderOptions = React.useMemo(getGroups, [slots]);
    if (props.hideSlotSelection && selected) {
        return React.createElement(NoDataToDisplay, { className: TIME_SLOTS.TIME_SLOT_HIDDEN, message: t("bookcart.timeslots.only_one_slot_available", {
                from: function () { return dateFormat(new Date(selected.from), t("bookcart.timeslots.timeslot_format")); },
                to: function () { return dateFormat(new Date(selected.to), t("bookcart.timeslots.timeslot_format")); },
                skipInterpolation: true
            }) });
    }
    if (renderOptions.length <= 0)
        return React.createElement(NoDataToDisplay, { message: t("bookcart.timeslots.all_timespans_booked_out") });
    var selectProps = {
        meta: props.meta,
        required: props.required,
        name: "timeslot_select",
        label: t("bookcart.timeslots.select_time_slot_time"),
        placeholder: t("bookcart.timeslots.select_time_slot_time_placeholder"),
        onChange: onSelect,
        value: deriveSlotValue(selected),
        options: renderOptions
    };
    return (React.createElement(Select, __assign({}, selectProps)));
});
var SlotRows = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: var(--ws-input-margin) -5px;\n"], ["\n    margin: var(--ws-input-margin) -5px;\n"])));
var templateObject_1;
